/**
 * Zweck: Beschreibt class RegisterRequest und ihren Daten- oder Funktionsvertrag.
 */
/**
 * Zweck: Beschreibt die TypeScript-Bausteine für den Frontend-Bereich frontend/src/app/models/register-request.ts.
 */
export class RegisterRequest {
  is_customer = false;
  company_name = '';
  company_uid = '';
  firstname = '';
  lastname = '';
  street = '';
  housenr = '';
  country = 'AT';
  plz = '';
  city = '';
  telnr = '';
  mail = '';
  password = '';

  interests: string[];

  agb = false;
  dsgvo = false;
}
